import React from 'react'
import { connect } from 'react-redux'
import Grid from '../../components/grid/loadable'
import MPU from '../../components/monthlyPayingUsers'
import styled from 'styled-components'

const DashboardOverallPage = () => {
  const Title = styled.h3`
    margin: 10px 0px 20px 10px;
  `
  const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px;
  `
  const graph = {
    title5: 'Retention rate by user life cycle (cohort analysis table) by booking appointment data, NOT payment',
  }

  return (
    <div>
      <div className="container-fluid">
        <MainContainer>
          <Title>Monthly paying users (MPU)</Title>
          <Grid gap="15px" width="900px">
            <MPU title={graph.title5} />
          </Grid>
        </MainContainer>
      </div>
    </div>
  )
}

export default DashboardOverallPage